import * as React from 'react';
import { QuestionnaireDto } from '../../../pages/questionnaire/questionnaireTypes';
import QuestionCatalogue from './QuestionCatalogue';
import { EmployeeDto } from '../../../pages/user/userTypes';
import { AnsweredCatalogueDto, getEmptyAnsweredCatalogue } from '../../../pages/answeredCatalogueTypes';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import Questionnaire from '../common/Questionnaire';

interface Props {
  questionnaire: QuestionnaireDto,
  currentEmployee: EmployeeDto,
  errorPage: JSX.Element
}

@observer
class QuestionnaireComponent extends React.Component<Props> {

  @observable
  private answeredCatalogue: AnsweredCatalogueDto = this.getAnswerCatalogueForCurrentEmployee();

  constructor(props: Props) {
    super(props);
    this.updateAnsweredCatalogue = this.updateAnsweredCatalogue.bind(this);
  }

  public render() {
    return (
      <Questionnaire
        questionnaire={this.props.questionnaire}>
        {{
          errorPage: this.props.errorPage,
          catalogue: this.renderCatalogue()
        }}
      </Questionnaire>
    )
  }

  private renderCatalogue() {
    return (
      <QuestionCatalogue endDate={this.props.questionnaire.endDate}
                         updateAnsweredCatalogue={this.updateAnsweredCatalogue}
                         questionCatalogue={this.props.questionnaire.catalogue}
                         answeredCatalogueDto={this.answeredCatalogue}/>
    )
  }

  private getAnswerCatalogueForCurrentEmployee(): AnsweredCatalogueDto {
    if (this.props.questionnaire.id === undefined) {
      return getEmptyAnsweredCatalogue()
    }

    const answeredCatalogue = this.props.questionnaire.answeredCatalogue.find(currentCatalogue => {
      return currentCatalogue.answerer.id === this.props.currentEmployee.id
    });

    if (answeredCatalogue === undefined) {
      return getEmptyAnsweredCatalogue()
    }

    return answeredCatalogue
  }

  private updateAnsweredCatalogue(updatedCatalogue: AnsweredCatalogueDto) {
        this.answeredCatalogue = updatedCatalogue
  }

}

export default QuestionnaireComponent;
